module.exports = __webpack_public_path__ + "static/media/npa-main-logo.4e30d3f0.png";